import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import moment from "moment";
import { Panel, PanelGroup } from "react-bootstrap";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";

import Loading from "../../common/Loading";

import { generateUniqueId } from "../../../utils";

// import { EMPLOYEE_SUMMARY_COLUMNS } from "./ columns";

const billedTypes = [
  "PREPAID",
  "BILLABLE",
  "FIXED FEE",
  "RETAINER",
  "CLIENTCARE",
  "TIER1",
  "TIER2",
  "CAPITAL",
  "MANAGED SERVICES"
];
const actualTypes = ["CAPITAL", "AS BILLED", "CREDIT", "OVERHEAD", "PERSONAL"];

const ProjectProgressList = ({ data, loading }) => {
  const [activeKey, setActiveKey] = useState(null);

  const columns = [
    "Prepaid Billed",
    "T&M Billed",
    "Fix Fee Billed",
    "Retainer Billed",
    "Client Care Billed",
    "Tiered 1 Billed",
    "Tiered 2 Billed",
    "Capital Billed",
    "Managed Serv Billable",
    "Total Billed",
    "Billable Actual",
    "Capital Actual",
    "As Bill Actual",
    "Credit Actual",
    "Overhead Actual",
    "Personal Actual",
    "Total Actual",
    "Billed Util Rate",
    "Total Util Rate"
  ];

  const getDaysDifference = (month, year) => {
    const startDate = moment([year, month - 1]).startOf("month");
    const endDate = moment([year, month - 1])
      .endOf("month")
      .endOf("day");
    const daysDifference = Math.round(
      (endDate - startDate + 1) / (1000 * 60 * 60 * 24)
    );
    let daysRemaining = daysDifference;
    let clonedDate = moment(startDate).clone();
    while (clonedDate <= moment(endDate)) {
      if (clonedDate.day() === 0 || clonedDate.day() === 6) {
        daysRemaining -= 1;
      }
      clonedDate = clonedDate.add(1, "days");
    }
    return daysRemaining;
  };

  const getSumsByDepartment = (users, labels, keyId, month, year) => {
    let totalBilledSum = 0;
    let totalBillableActual = 0;
    let totalAsBilledActual = 0;
    let totalCreditActual = 0;
    let totalOverheadActual = 0;
    let totalCapitalSum = 0;
    let billedUtilRateSum = 0;
    let totalUtilRateSum = 0;
    let totalPersonalActual = 0;
    let totalActual = 0;

    const billedColums = labels.map((label, i) => {
      let callTypeTotal = 0;
      users.forEach((u) => {
        let tempBilledUtilRateSum = 0;
        let tempTotalUtilRateSum = 0;
        u.callTypes.forEach((callType) => {
          if (callType.callTypeName === label) {
            callTypeTotal += callType.billableHours;
            tempBilledUtilRateSum += callType.actualHours;
            tempTotalUtilRateSum += callType.actualHours;
            totalBilledSum += callType.billableHours;
            totalBillableActual += callType.actualHours;
            totalActual += callType.actualHours;
          } else if (callType.callTypeName === "AS BILLED" && i === 0) {
            totalAsBilledActual += callType.actualHours;
            tempTotalUtilRateSum += callType.actualHours;
            totalActual += callType.actualHours;
          } else if (callType.callTypeName === "CREDIT" && i === 0) {
            totalCreditActual += callType.actualHours;
            totalActual += callType.actualHours;
          } else if (callType.callTypeName === "OVERHEAD" && i === 0) {
            totalOverheadActual += callType.actualHours;
            totalActual += callType.actualHours;
          } else if (callType.callTypeName === "CAPITAL" && i === 0) {
            totalCapitalSum += callType.actualHours;
            tempTotalUtilRateSum += callType.actualHours;
            totalActual += callType.actualHours;
          } else if (callType.callTypeName === "PERSONAL" && i === 0) {
            totalPersonalActual += callType.actualHours;
            totalActual += callType.actualHours;
          }
        });
        if (u.employmentStatus === "Salary") {
          const difference = getDaysDifference(month, year) * 8;
          billedUtilRateSum += (tempBilledUtilRateSum / difference) * 100;
          totalUtilRateSum += (tempTotalUtilRateSum / difference) * 100;
        } else {
          billedUtilRateSum +=
            (tempBilledUtilRateSum / u.actualHours || 0) * 100;
          totalUtilRateSum += (tempTotalUtilRateSum / u.actualHours || 0) * 100;
        }
      });
      return (
        <td key={`${keyId}-${label}`} style={{ textAlign: "right" }}>
          {!Number.isNaN(callTypeTotal)
            ? callTypeTotal.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, "$&,")
            : ""}
        </td>
      );
    });
    return (
      <React.Fragment>
        {billedColums}
        <td key={`total-${keyId}`} style={{ textAlign: "right" }}>
          {totalBilledSum.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
        </td>
        <td
          key={`total-billable-actual-${keyId}`}
          style={{ textAlign: "right" }}
        >
          {totalBillableActual.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
        </td>
        <td key={`total-capital-${keyId}`} style={{ textAlign: "right" }}>
          {totalCapitalSum.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
        </td>
        <td key={`total-as-billed-${keyId}`} style={{ textAlign: "right" }}>
          {totalAsBilledActual.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
        </td>
        <td key={`total-credit-${keyId}`} style={{ textAlign: "right" }}>
          {totalCreditActual.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
        </td>
        <td key={`total-overhead-${keyId}`} style={{ textAlign: "right" }}>
          {totalOverheadActual.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
        </td>
        <td key={`total-personal-${keyId}`} style={{ textAlign: "right" }}>
          {totalPersonalActual.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
        </td>
        <td key={`total-actual-${keyId}`} style={{ textAlign: "right" }}>
          {totalActual.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
        </td>
        <td key={`billed-util-rate-${keyId}`} style={{ textAlign: "right" }}>
          {`${(billedUtilRateSum / users.length)
            .toFixed(1)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,")} %`}
        </td>
        <td key={`total-util-rate-${keyId}`} style={{ textAlign: "right" }}>
          {`${(totalUtilRateSum / users.length)
            .toFixed(1)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,")} %`}
        </td>
      </React.Fragment>
    );
  };

  const generateUtilRate = (user, totalType = false, month, year) => {
    let tempBilledUtilRate = 0;
    let tempTotalUtilRate = 0;
    user.callTypes.forEach((callType) => {
      if (callType.isBillable) {
        tempBilledUtilRate += callType.actualHours;
        tempTotalUtilRate += callType.actualHours;
      }
      if (callType.callTypeName === "AS BILLED") {
        tempTotalUtilRate += callType.actualHours;
      }
      if (callType.callTypeName === "CAPITAL") {
        tempTotalUtilRate += callType.actualHours;
      }
    });
    const difference = getDaysDifference(month, year) * 8;
    if (user.employmentStatus === "Salary") {
      return totalType
        ? ((tempTotalUtilRate / difference) * 100).toFixed(2)
        : ((tempBilledUtilRate / difference) * 100).toFixed(2);
    }
    return totalType
      ? ((tempTotalUtilRate / user.actualHours || 0) * 100).toFixed(2)
      : ((tempBilledUtilRate / user.actualHours || 0) * 100).toFixed(2);
  };
  const generateBillableActual = (user) => {
    let totalActual = 0;
    user.callTypes.forEach((callType) => {
      if (callType.isBillable) {
        totalActual += callType.actualHours;
      }
    });
    return totalActual.toFixed(2);
  };

  const getEmploymentStatusLabel = (employmentStatus) => {
    let label = "";
    switch (employmentStatus) {
      case "Consultant":
        label = " (C)";
        break;
      case "Intern":
        label = " (I)";
        break;
      case "Hourly":
        label = " (H)";
        break;
      default:
        break;
    }
    return label;
  };

  const handleSelect = (selectedKey) => {
    setActiveKey(selectedKey);
  };

  useEffect(() => {
    if (data && data.length) {
      setActiveKey(
        `${data[0]._id.department}-${data[0]._id.month}/${data[0]._id.year}`
      );
    }
  }, [data]);

  if (loading) {
    return (
      <div className="loading">
        <Loading />
      </div>
    );
  }
  if (!data || !data.length) {
    return (
      <div className="loading">
        <h4 style={{ opacity: 0.15 }}>No Data</h4>
      </div>
    );
  }

  return (
    <div className="content-wrapper">
      <PanelGroup
        accordion
        id="accordion-esd-department"
        activeKey={activeKey}
        onSelect={handleSelect}
      >
        {data.map((item) => (
          <Panel
            key={generateUniqueId()}
            eventKey={`${item._id.department}-${item._id.month}/${item._id.year}`}
          >
            <Panel.Heading>
              <Panel.Title toggle>
                {activeKey ===
                `${item._id.department}-${item._id.month}/${item._id.year}` ? (
                  <IoChevronUp
                    size="1.3em"
                    style={{ verticalAlign: "middle", paddingRight: "5px" }}
                  />
                ) : (
                  <IoChevronDown
                    size="1.3em"
                    style={{ verticalAlign: "middle", paddingRight: "5px" }}
                  />
                )}
                {`${item.description} ${item.month}/${item.year}`}
              </Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible style={{ overflow: "auto" }}>
              {activeKey ===
                `${item._id.department}-${item._id.month}/${item._id.year}` && (
                <table>
                  <thead>
                    <tr
                      style={{
                        background: "#286090",
                        color: "white",
                        fontSize: 10
                      }}
                    >
                      <th>Employee</th>
                      {columns.map((column) => (
                        <th key={column}>{column}</th>
                      ))}
                    </tr>
                    {/* USER ROWS */}
                    {item.employees.map((employee) => (
                      <tr key={employee.employee} style={{ fontSize: 12 }}>
                        <td>
                          {employee.employeeName}
                          {getEmploymentStatusLabel(employee.employmentStatus)}
                        </td>
                        {billedTypes.map((type) => (
                          <td
                            style={{ textAlign: "right" }}
                            key={generateUniqueId()}
                          >
                            {employee.callTypes
                              .find((t) => t.callTypeName === type)
                              ?.billableHours?.toFixed(2) || 0}
                          </td>
                        ))}
                        <td style={{ textAlign: "right" }}>
                          {employee.billableHours?.toFixed(2) || 0}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {generateBillableActual(employee)}{" "}
                        </td>
                        {actualTypes.map((type) => (
                          <td
                            key={generateUniqueId()}
                            style={{ textAlign: "right" }}
                          >
                            {employee.callTypes
                              .find((t) => t.callTypeName === type)
                              ?.actualHours?.toFixed(2) || 0}
                          </td>
                        ))}
                        <td style={{ textAlign: "right" }}>
                          {employee.actualHours?.toFixed(2) || 0}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {generateUtilRate(
                            employee,
                            false,
                            item.month,
                            item.year
                          )}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {generateUtilRate(
                            employee,
                            true,
                            item.month,
                            item.year
                          )}
                        </td>
                      </tr>
                    ))}
                    {/* TOTAL ROW */}
                    <tr style={{ fontWeight: "bold", fontSize: 12 }}>
                      <td>Total</td>
                      {getSumsByDepartment(
                        item.employees,
                        billedTypes,
                        item._id.department,
                        item.month,
                        item.year
                      )}
                    </tr>
                  </thead>
                </table>
              )}
            </Panel.Body>
          </Panel>
        ))}
      </PanelGroup>
    </div>
  );
};
ProjectProgressList.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool
};
export default ProjectProgressList;
